import defaultAttributes from '../defaultAttributes';

const CircleDot = [
  'svg',
  defaultAttributes,
  [
    ['circle', { cx: '12', cy: '12', r: '10' }],
    ['circle', { cx: '12', cy: '12', r: '1' }],
  ],
];

export default CircleDot;
